import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';
import { RequestQueueProvider } from './services/requestQueue';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContextProvider>
    <RequestQueueProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </RequestQueueProvider>
  </ContextProvider>
);
